var exports = {
  "kL": "CompactVoiceCallView.module__container___dlpPM1",
  "gw": "CompactVoiceCallView.module__containerNoHeader___dlpPM1",
  "lf": "CompactVoiceCallView.module__containerReserveHeaderChrome___dlpPM1",
  "L7": "CompactVoiceCallView.module__containerNoControlBar___dlpPM1",
  "ap": "CompactVoiceCallView.module__containerFillHeight___dlpPM1",
  "tZ": "CompactVoiceCallView.module__contentArea___dlpPM1",
  "$7": "CompactVoiceCallView.module__contentAreaAudioOnly___dlpPM1",
  "OZ": "CompactVoiceCallView.module__audioAvatarLayout___dlpPM1",
  "a3": "CompactVoiceCallView.module__audioAvatarLayoutInner___dlpPM1",
  "d6": "CompactVoiceCallView.module__audioAvatarLayoutFullBleed___dlpPM1",
  "nd": "CompactVoiceCallView.module__audioAvatarLayoutInnerFullBleed___dlpPM1",
  "Gq": "CompactVoiceCallView.module__audioAvatarList___dlpPM1",
  "D9": "CompactVoiceCallView.module__layoutHost___dlpPM1",
  "pl": "CompactVoiceCallView.module__layoutHostFullHeight___dlpPM1",
  "DO": "CompactVoiceCallView.module__layoutHostFullHeightGrid___dlpPM1",
  "vR": "CompactVoiceCallView.module__layoutHostFullHeightFocus___dlpPM1",
  "_t": "CompactVoiceCallView.module__controlBarSection___dlpPM1",
  "Vw": "CompactVoiceCallView.module__controlBarInner___dlpPM1",
  "AD": "CompactVoiceCallView.module__fullscreenButtonWrap___dlpPM1",
  "uA": "CompactVoiceCallView.module__fullscreenButtonWrapMobileWithControls___dlpPM1",
  "I": "CompactVoiceCallView.module__heightToggleButtonWrap___dlpPM1",
  "Ip": "CompactVoiceCallView.module__heightToggleButtonShell___dlpPM1",
  "x8": "CompactVoiceCallView.module__heightTogglePill___dlpPM1",
  "_A": "CompactVoiceCallView.module__heightTogglePillIcon___dlpPM1",
  "oP": "CompactVoiceCallView.module__heightToggleUnreadBadge___dlpPM1",
  "Di": "CompactVoiceCallView.module__resizeHandle___dlpPM1",
  "YC": "CompactVoiceCallView.module__resizePill___dlpPM1",
  "$I": "CompactVoiceCallView.module__containerResizing___dlpPM1",
};

module.exports = exports;
